// @flow

import { request } from '../../utils'

export const addToCartKiehls = (customerId: string, subscriberId: string, productId: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    request({
      url: '/cartadd/?ajax=true',
      data: {
        pid: productId,
        quantity: '1'
      },
      processResponse: (xhr) => {
        if (xhr.status >= 200 && xhr.status < 400) {
          resolve()
        } else {
          reject(new Error('Add-to-cart failed.'))
        }
      }
    })
  })
}
